import { render, staticRenderFns } from "./Consultancy.vue?vue&type=template&id=65b275d8"
import script from "./Consultancy.vue?vue&type=script&lang=js"
export * from "./Consultancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports